module.exports = __webpack_public_path__ + "img/woman-normal-bg-coffee.dd5963c2.jpg";